import { useCallback, useSyncExternalStore } from 'react';

export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

function getMediaQueryList(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(query);
}

export function useMediaQuery(query: string, serverValue = false): boolean {
  const subscribe = useCallback(
    (listener: () => void) => {
      const list = getMediaQueryList(query);
      if (!list) return () => {};
      list.addEventListener('change', listener);
      return () => list.removeEventListener('change', listener);
    },
    [query],
  );
  const getSnapshot = useCallback(
    () => getMediaQueryList(query)?.matches ?? serverValue,
    [query, serverValue],
  );
  return useSyncExternalStore(subscribe, getSnapshot, () => serverValue);
}

/** Matches Tailwind's `lg` breakpoint. */
export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_MEDIA_QUERY);
}
